import { render, staticRenderFns } from "./gBackTop.vue?vue&type=template&id=28f3b812&scoped=true&"
import script from "./gBackTop.vue?vue&type=script&lang=js&"
export * from "./gBackTop.vue?vue&type=script&lang=js&"
import style0 from "./gBackTop.vue?vue&type=style&index=0&id=28f3b812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3b812",
  null
  
)

export default component.exports